(() => {
  const AGE_COLLECTIONS_URL = '/collections';
  const selector = 'cart-drawer.is-empty #CartDrawer .cart-drawer__empty-content > a.button';

  function updateEmptyCartLink() {
    const link = document.querySelector(selector);
    if (link) link.setAttribute('href', AGE_COLLECTIONS_URL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateEmptyCartLink, { once: true });
  } else {
    updateEmptyCartLink();
  }

  document.addEventListener('shopify:section:load', updateEmptyCartLink);

  // Delegation also covers the link when the drawer is re-rendered after the cart becomes empty.
  document.addEventListener('click', (event) => {
    const link = event.target.closest(selector);
    if (!link) return;

    event.preventDefault();
    window.location.assign(AGE_COLLECTIONS_URL);
  });
})();
